import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  PLATFORM_ID,
  inject,
  signal,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

interface NavLink {
  label: string;
  path: string;
}

@Component({
  selector: 'app-header',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  readonly menuOpen = signal(false);
  readonly scrolled = signal(false);

  readonly primaryNav: NavLink[] = [
    { label: 'Tenant Referencing', path: '/tenant-referencing' },
    { label: 'Rent Guarantee', path: '/rent-guarantee-insurance' },
    { label: 'HMO Cover', path: '/hmo-rent-guarantee-insurance' },
    { label: 'Deposit Replacement', path: '/deposit-replacement' },
    { label: 'For Agents', path: '/for-agents' },
    { label: 'Contact', path: '/contact' },
  ];

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly platformId = inject(PLATFORM_ID);

  @HostBinding('attr.role') role = 'banner';

  @HostListener('window:scroll')
  onScroll(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.scrolled.set(window.scrollY > 40);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.menuOpen() && !this.host.nativeElement.contains(event.target as Node)) {
      this.menuOpen.set(false);
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.menuOpen.set(false);
  }

  toggleMenu(): void {
    this.menuOpen.update((v) => !v);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }
}
